// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---md-lorem-ipsum-md": () => import("./../../../md/lorem-ipsum.md" /* webpackChunkName: "component---md-lorem-ipsum-md" */),
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

